import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Grid,
  TextField,
  Divider,
  IconButton,
  MenuItem,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { IconRubrics } from "Icons";
import { useHistory } from "react-router-dom";
import { withApiContext, withLabelsContext, withUserContext, withWindowContext } from "context";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

const RubricsModal = (props) => {
  const { open, onClose, ctx_user, ctx_api } = props;
  const history = useHistory();
  const [form, setForm] = useState({
    assessmentName: "",
    description: "",
    shortName: "",
    subject: "",
    standard: "",
  });

  const [subjects, setSubjects] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loadingSubjects, setLoadingSubjects] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const isFormValid =
  form.assessmentName.trim() !== "" &&
  form.subject.trim() !== "" &&
  form.standard.trim() !== "";

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  useEffect(() => {
    if (!open) {
      return;
    }

    let isCancelled = false;

    const fetchSubjects = async () => {
      setLoadingSubjects(true);
      try {
        const { rsp } = await ctx_api.privateRequest({
          cmd: "get_subject_names",
          args: {},
        });

        if (isCancelled) {
          return;
        }

        const normalised = Array.isArray(rsp)
          ? rsp.map(({ curriculum_id, name }) => ({
            label: name,
            value: curriculum_id,
          }))
          : [];

        setSubjects(normalised);
        setForm((prev) => {
          if (!normalised.length) {
            return { ...prev, subject: "" };
          }
          const hasExistingSelection = normalised.some(
            (subject) => subject.value === prev.subject
          );
          return hasExistingSelection ? prev : { ...prev, subject: "" };
        });
      } catch (error) {
        if (!isCancelled) {
          console.error("Failed to fetch subjects", error);
          props.ctx_window?.alert?.("Unable to load subjects. Please try again later.");
        }
      } finally {
        if (!isCancelled) {
          setLoadingSubjects(false);
        }
      }
    };

    fetchSubjects();

    return () => {
      isCancelled = true;
    };
  }, [open, ctx_api, ctx_user, props.ctx_window]);

  // const validateForm = () => {
  //   if (!form.assessmentName.trim()) {
  //     props.ctx_window?.alert?.("Assessment name is required");
  //     return false;
  //   }
  //    if (!form.subject.trim()) {
  //     props.ctx_window?.alert?.("Subject is required");
  //     return false;
  //   }
  //    if (!form.assessmentName.trim()) {
  //     props.ctx_window?.alert?.("standard is required");
  //     return false;
  //   }
  //   return true;
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("Submit clicked");

  // if (!validateForm()) {
  //   console.log("Validation failed");
  //   return;
  // }

  setSaving(true);

  try {
    const payload = {
      name: form.assessmentName.trim(),
      description: form.description,
      short_name: form.shortName,
      category_id: form.standard || null,
      curriculum_id: form.subject || null,
      status: 1,
      memberId: ctx_user?.user?.id,
      orgId: ctx_user?.user?.organizationId,
      goiId: ctx_user?.user?.goiId,
    };

    console.log("Payload before API:", payload);

    // 🔍 Wrap API call in its own try/catch
    let response;
    try {
      response = await ctx_api.privateRequest({
        cmd: "insert_update_rubrics",
        args: payload,
      });
      console.log("Raw API response:", response);
    } catch (apiErr) {
      console.error("API request threw an error:", apiErr);
      throw apiErr; // rethrow to trigger outer catch
    }

    const { rsp } = response || {};
    const normalizedRsp = Array.isArray(rsp) ? rsp[0] : rsp;
    console.log("Normalized Response:", normalizedRsp);
console.log(props.ctx_window)
    
    
    if (normalizedRsp?.StatusValue === 1) {
      props.ctx_window?.alert?.("Rubrics saved successfully");
      const newAssessmentId =
        normalizedRsp?.rubrics_assessment_id ??
        null;
      onClose();
      history.push({
        pathname: "/Rubrics-assessment",
        state: {
          action: "update",
          assessmentId: newAssessmentId,
          assessmentName: form.assessmentName.trim(),
        },
      });
    } else {
      throw new Error(normalizedRsp?.StatusText || "Failed to save rubrics");
    }
  } catch (error) {
    console.error("Error saving rubrics:", error);
    props.ctx_window?.alert?.(
      error.message || "Something went wrong while saving rubrics"
    );
  } finally {
    setSaving(false);
    console.log("Saving ended");
  }
};



  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "750px",
            borderRadius: "20px",
            overflow: "hidden",
            p: 1,
            backdropFilter: "blur(12px)",
            backgroundColor: "rgba(255,255,255,0.85)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(4px)",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 3,
            py: 1.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconRubrics style={{ width: 28, height: 28, objectFit: "contain" }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Rubrics Test
            </Typography>
          </Box>

          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 12,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent sx={{ px: 4, py: 3 }}>
          <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 2 }}>
            Create Rubrics
          </Typography>
          <Divider sx={{ mb: 3 }} />

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} justifyContent="space-between" alignItems="flex-start">
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <Typography variant="subtitle2">Assessment Name <span style={{ color: "red" }}>*</span></Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Assessment Name"
                      value={form.assessmentName}
                      onChange={handleChange("assessmentName")}
                    />
                  </Grid>

                  <Grid item>
                    <Typography variant="subtitle2">Short Name </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Short Name"
                      value={form.shortName}
                      onChange={handleChange("shortName")}
                    />
                  </Grid>

                  <Grid item>
                    <Typography variant="subtitle2">Subject <span style={{ color: "red" }}>*</span></Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      placeholder="Select Subject"
                      value={form.subject}
                      onChange={handleChange("subject")}
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem disabled value="">
                        {loadingSubjects ? "Loading subjects..." : "Select Subject"}
                      </MenuItem>
                      {subjects.map((subject) => (
                        <MenuItem key={subject.value} value={subject.value}>
                          {subject.label}
                        </MenuItem>
                      ))}

                    </TextField>
                  </Grid>

                  <Grid item>
                    <Typography variant="subtitle2">Standard <span style={{ color: "red" }}>*</span></Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      placeholder="Select Standard"
                      value={form.standard}
                      onChange={handleChange("standard")}
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem disabled value="">
                        Select Standard
                      </MenuItem>
                      {(ctx_user?.user?.campusCategories || []).map((category) => (
                        <MenuItem key={category.value || category.id} value={category.value || category.id}>
                          {category.label || category.name}
                        </MenuItem>
                      ))}

                    </TextField>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2">Description</Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={8}
                  size="small"
                  placeholder="Enter Description"
                  value={form.description}
                  onChange={handleChange("description")}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        {/* Footer */}
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={saving || !isFormValid}
            sx={{
              backgroundColor: "#00AEEF",
              color: "#fff",
              textTransform: "none",
              px: 3,
              "&:hover": { backgroundColor: "#0096D6" },
              mr: 2,
            }}
          >
            {saving ? "Saving..." : "Save and Add"}
          </Button>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: "#f44336",
              color: "#fff",
              textTransform: "none",
              px: 3,
              "&:hover": { backgroundColor: "#c62828" },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default withApiContext(
  withUserContext(withLabelsContext(withWindowContext(RubricsModal)))
);